import FAQ from './FAQ';

function LaadpaalFAQ() {
  const faqs = [
    {
      question: 'Welke laadpaal heb ik nodig?',
      answer: 'De keuze voor een laadpaal hangt af van uw elektrische auto, laadsnelheid wensen en stroomaansluiting. We adviseren meestal een 11kW of 22kW laadpaal voor thuisgebruik. Bij de installatie controleren we of uw meterkast geschikt is.'
    },
    {
      question: 'Heb ik een 3-fase aansluiting nodig voor een laadpaal?',
      answer: 'Voor optimaal laden is een 3-fase aansluiting aan te raden. Dit maakt laden met 11kW of 22kW mogelijk. Bij een gewone aansluiting is de laadsnelheid beperkt tot 3,7kW. We kunnen uw aansluiting indien nodig upgraden.'
    },
    {
      question: 'Wat zijn de installatiekosten van een laadpaal?',
      answer: 'De installatiekosten variëren van €500 tot €1.500, afhankelijk van de situatie. Factoren zijn de afstand tot de meterkast, eventuele graafwerkzaamheden en of de meterkast aangepast moet worden. We maken altijd eerst een gratis inspectie.'
    },
    {
      question: 'Hoe lang duurt de installatie van een laadpaal?',
      answer: 'Een standaard laadpaal installatie duurt ongeveer 4-6 uur. Als er extra werkzaamheden nodig zijn, zoals het verzwaren van de aansluiting of graafwerk, kan dit 1-2 dagen duren. We maken vooraf een duidelijke planning.'
    },
    {
      question: 'Kan ik subsidie krijgen voor een laadpaal?',
      answer: 'Ja, in veel gemeenten is subsidie beschikbaar voor de aanschaf en installatie van een laadpaal. Ook zijn er vaak fiscale voordelen voor bedrijven. We kunnen u adviseren over de mogelijkheden en helpen bij de aanvraag.'
    }
  ];

  return <FAQ title="Veelgestelde vragen over laadpalen" faqs={faqs} />;
}

export default LaadpaalFAQ;